export const COMPANY_RADIUS_DEFAULTS = 'COMPANY_RADIUS_DEFAULTS'

export const dispatchCompanyRadiusDefaults = (
  data: {
    radius1: number
    radius2: number
    radius3: number
    radius4: number
  } | null
) => ({
  type: COMPANY_RADIUS_DEFAULTS,
  data,
})
